export const TeacherGradeCourseType = {
  normalCourse: 'normal_course',
  polishingCourse: 'polishing_course',
};

export const DEFAULT_TEACHER_GRADE_COURSE_TYPE = TeacherGradeCourseType.normalCourse;

export const TeacherGradeCourseTypeLabel = {
  [TeacherGradeCourseType.normalCourse]: '正常课程',
  [TeacherGradeCourseType.polishingCourse]: '润色课程',
};

export const normalizeTeacherGradeCourseType = (value) =>
  Object.values(TeacherGradeCourseType).includes(value)
    ? value
    : DEFAULT_TEACHER_GRADE_COURSE_TYPE;

export const getTeacherGradeCourseTypeLabel = (value) =>
  TeacherGradeCourseTypeLabel[normalizeTeacherGradeCourseType(value)];

const buildTeacherGradeOptions = (grades) =>
  grades.map((grade) => ({
    label: grade,
    value: grade,
  }));

const NormalTeacherGradeGrades = ['A', 'B+', 'B', 'B-', 'C', 'D'];
const PolishingTeacherGradeGrades = ['免检', 'A', 'B+', 'B', 'B-', 'C'];

export const TeacherGradeOptions = buildTeacherGradeOptions(NormalTeacherGradeGrades);

export const PolishingTeacherGradeOptions = buildTeacherGradeOptions(PolishingTeacherGradeGrades);

export const AllTeacherGradeOptions = buildTeacherGradeOptions([
  ...new Set([...PolishingTeacherGradeGrades, ...NormalTeacherGradeGrades]),
]);

export const getTeacherGradeOptions = (gradeType = DEFAULT_TEACHER_GRADE_COURSE_TYPE) =>
  normalizeTeacherGradeCourseType(gradeType) === TeacherGradeCourseType.polishingCourse
    ? PolishingTeacherGradeOptions
    : TeacherGradeOptions;

const NormalTeacherGradeSelectFields = [
  {
    name: 'professional',
    label: '专业度',
    options: [
      '老师专业度很高，知识点讲解很清晰',
      '老师专业度一般，知识点讲解的一般，基本可以把知识点讲清楚',
      '老师专业度较差，讲解不清晰且有比较明显的错误',
    ],
  },
  {
    name: 'preparation',
    label: '备课（讲义）',
    options: [
      '有自行准备讲义，在课堂上讲解流畅',
      '有根据学生给的教授的讲义或者资料添加高光以及中文或者英文批注等备课痕迹,在课堂上讲解流畅',
      '讲课直接使用学生给的教授的讲义或者资料，课堂上讲解流畅',
      '基本没有备课痕迹，但是内容较简单，讲解基本流畅，勉强可以应付',
      '没有备课痕迹，老师在课堂上讲解非常不流畅',
    ],
  },
  {
    name: 'blackboard',
    label: '板书',
    options: [
      '老师有板书且字迹清晰，工整',
      '老师有简单的板书，但是字迹比较乱',
      '老师上课使用鼠标板书，字迹乱、效率低',
      '老师打字标注，打字速度很快，不影响课堂效果',
      '老师打字标注，效率比较低，影响课堂效果',
      '老师没有板书',
      '这门课性质特殊，基本不需要板书',
    ],
  },
  {
    name: 'interaction',
    label: '课堂互动',
    options: [
      '老师非常积极和学生进行课上互动，学生也积极反馈，课堂氛围很好',
      '老师有简单的互动，能根据学生的反馈调整节奏',
      '老师基本没有互动，完全按照自己的节奏讲课',
      '老师有互动，但是学生自身问题，基本没有给到老师回应',
    ],
  },
  {
    name: 'feedback',
    label: '课后反馈',
    options: [
      '课后反馈写的很认真，对于课程内容、学生课堂表现都有详细的反馈。对于学生的学习情况比较负责，能做到及时风险预警',
      '课后反馈写的中规中矩，基本能够反应学生课堂的情况',
      '课后反馈写的比较敷衍，没有真实反应学生上课情况',
    ],
  },
  {
    name: 'pace',
    label: '课堂节奏',
    options: [
      '老师上课节奏较快，适合基础好的学生',
      '老师上课节奏适中，适合大多数类型的学生',
      '老师上课节奏较慢，适合基础差的学生',
    ],
  },
  {
    name: 'experience',
    label: '授课经验',
    options: [
      '老师有丰富的授课经验，对课堂的掌控和应变能力比较好',
      '老师有辅导经验，但是经验不是很多',
      '老师完全没有辅导经验',
    ],
  },
];

const PolishingTeacherGradeSelectFields = [
  {
    name: 'assignmentRequirement',
    label: '作业要求讲解',
    options: [
      '未讲解作业要求',
      '只简略过了一遍作业要求',
      '对重点作业要求进行加粗标黄等',
      '主动强调要求中的易错点',
    ],
  },
  {
    name: 'writingStructure',
    label: '写作结构讲解',
    options: [
      '未给学生提供写作的结构',
      '提供了写作结构，但未讲解每个结构应该如何写',
      '详细讲解每个结构需要包含的部分',
      '主动强调结构中的易错点',
    ],
  },
  {
    name: 'writingSample',
    label: '写作Sample讲解',
    options: [
      '每一部分未给学生提供素材',
      '给学生提供了相关的素材，但仅粗略过了一遍',
      '提供相关素材并带着学生中文/英文写了一些样例',
    ],
  },
  {
    name: 'referenceSample',
    label: 'Reference样例讲解',
    options: [
      '未讲解reference',
      '有提到reference要求，但并未给学生提供工具',
      '有提到reference要求，给学生提供工具',
      '有提到reference要求，给学生提供工具，并且有sample',
    ],
  },
  {
    name: 'professional',
    label: '专业度',
    options: [
      '老师专业度较差，讲解不清晰且有比较明显的错误',
      '老师专业度一般，知识点讲解的一般，基本可以把知识点讲清楚',
      '老师专业度很高，知识点讲解很清晰',
    ],
  },
];

const CommentField = {
  name: 'comment',
  label: '其他需要关注的信息',
  type: 'textarea',
};

const TeacherGradeFormFields = {
  [TeacherGradeCourseType.normalCourse]: [...NormalTeacherGradeSelectFields, CommentField],
  [TeacherGradeCourseType.polishingCourse]: [...PolishingTeacherGradeSelectFields, CommentField],
};

const TeacherGradeDetailFields = {
  [TeacherGradeCourseType.normalCourse]: [
    ...NormalTeacherGradeSelectFields,
    { name: 'character', label: '老师性格' },
    { name: 'communication', label: '沟通情况' },
    CommentField,
  ],
  [TeacherGradeCourseType.polishingCourse]: [...PolishingTeacherGradeSelectFields, CommentField],
};

export const getTeacherGradeFormFields = (gradeType = DEFAULT_TEACHER_GRADE_COURSE_TYPE) =>
  TeacherGradeFormFields[normalizeTeacherGradeCourseType(gradeType)];

export const getTeacherGradeDetailFields = (gradeType = DEFAULT_TEACHER_GRADE_COURSE_TYPE) =>
  TeacherGradeDetailFields[normalizeTeacherGradeCourseType(gradeType)];

export const TeacherGradeCourseTypeOptions = Object.values(TeacherGradeCourseType).map((value) => ({
  label: TeacherGradeCourseTypeLabel[value],
  value,
}));
